export class UserRegistration {
    public idpName: string;
    public idpTitle: string;
    private description: string;
    public userEmail: string;
    public isUserRegistered: boolean;
    public idpDescription: any;
    public idpProductUrl: string;
    private acsUrl: string;
    private loginUrl: string;

    constructor(name: string, title: string, userEmail: string, isUserRegistered: boolean, description: string, idpProductUrl: string, acsUrl: string, loginUrl: string) {
        this.idpName = name;
        this.idpTitle = title;
        this.description = description;
        this.idpProductUrl = idpProductUrl;
        this.userEmail = userEmail;
        this.isUserRegistered = isUserRegistered;
        this.acsUrl = acsUrl;
        this.loginUrl = loginUrl;
    }

    get IdpName(): string {
        return this.idpName;
    }

    get IdpTitle(): string {
        return this.idpTitle;
    }

    get IdpDescription(): string {
        return this.description;
    }

    get IdpProductUrl(): string {
        return this.idpProductUrl;
    }

    get UserEmail(): string {
        return this.userEmail;
    }

    get IsUserRegistered(): boolean {
        return this.isUserRegistered;
    }

    get AcsUrl(): string {
        return this.acsUrl;
    }

    get LoginUrl(): string {
        return this.loginUrl;
    }
}

